import highlight01 from "../backgrounds/highlights/highlight-1.jpg";
import highlight02 from "../backgrounds/highlights/highlight-2.jpg";
import highlight03 from "../backgrounds/highlights/highlight-3.jpg";

export function getPostHighlightBackground() {
  const backgrounds = [highlight01, highlight02, highlight03];
  return backgrounds[Math.floor(Math.random() * backgrounds.length)];
}
